import { unAuthRoutes } from "@/router";
import { getRoutes, saveSystemSetting, getQQCount } from "@/api/base";
import { convertRouter } from "@/utils/handleRoutes";

const state = () => ({
  routes: [],
  systemSetting: {},
});

const getters = {
  routes: (state) => state.routes,
  systemSetting: (state) => state.systemSetting,
};

const mutations = {
  setRoutes(state, routes) {
    state.routes = unAuthRoutes.concat(routes);
  },
  setSetting(state, setting) {
    state.systemSetting = setting;
  },
};

/**
 * 递归查找并隐藏指定路径的路由
 */
function setRouteHiddenByPath(routes, targetPath) {
  for (const route of routes) {
    if (route.path === targetPath) {
      if (route.meta) {
        route.meta.isHidden = true;
      }
      return;
    }
    if (route.children && route.children.length > 0) {
      setRouteHiddenByPath(route.children, targetPath);
    }
  }
}

const actions = {
  async setRoutes({ commit }) {
    let { data } = await getRoutes();
    data.routes.push({ path: "*", redirect: "/404", hidden: true });
    let accessRoutes = convertRouter(data.routes);

    // 根据QQ账号数量控制"QQ接单"菜单显示
    try {
      const qqResult = await getQQCount();
      const qqCount = qqResult.data || 0;
      if (qqCount === 0) {
        setRouteHiddenByPath(accessRoutes, 'bot-message');
      }
    } catch (e) {
      console.error('获取QQ账号数量失败，默认隐藏QQ接单菜单:', e);
      setRouteHiddenByPath(accessRoutes, 'bot-message');
    }

    commit("setRoutes", accessRoutes);
    commit("setSetting", data.systemSetting);
    return accessRoutes;
  },
  async changeSettingItem({ commit }, setting) {
    saveSystemSetting(setting);
  },
};

export default { state, getters, mutations, actions };
